const discountForm = document.querySelector('.discount__form');
if (discountForm) {
  const discountFormButton = discountForm.querySelector('.discount__form-button');
  const discountFormInput = discountForm.querySelector('.discount__form-input input');
  const discountFormError = discountForm.querySelector('.discount__form-error');

  discountFormButton.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const discount_code = discountFormInput.value.trim();
    if (!discount_code) {
      showError(theme.settings.discount_form_error_empty_code);
      return;
    }

    // Set loading state
    setLoadingState(true);

    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartResponse.json();

      const existingTitles = cartData.cart_level_discount_applications.map(item => item.title);
      const existingDiscountCodes = cartData.discount_codes.map(item => item.code);
      const hasExistingDiscounts = existingTitles.length > 0 || existingDiscountCodes.length > 0;
      
      const discountString = [...existingTitles, ...existingDiscountCodes, discount_code].join(',');

      const formData = new FormData();
      formData.append('discount', discountString);

      const updateResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      });
      const updatedCart = await updateResponse.json();

      let isFoundCode = updatedCart.cart_level_discount_applications.some(
        item => item.discount_application.title.trim().toLowerCase() === discount_code.toLowerCase()
      );

      let isApplicableCode = isFoundCode;

      if (!isFoundCode) {
        const foundDiscountCode = updatedCart.discount_codes.find(
          item => item.code.toLowerCase() === discount_code.toLowerCase()
        );
        
        if (foundDiscountCode) {
          isFoundCode = true;
          isApplicableCode = foundDiscountCode.applicable === true;
        }
      }

      // Check if new code was not added but existing discounts were removed (incompatibility)
      const newTitles = updatedCart.cart_level_discount_applications.map(item => item.title);
      const newDiscountCodes = updatedCart.discount_codes.map(item => item.code);
      const existingDiscountsRemoved = hasExistingDiscounts && 
        (newTitles.length < existingTitles.length || newDiscountCodes.length < existingDiscountCodes.length);

      if (isFoundCode && isApplicableCode) {
        discountFormError.style.display = 'none';
        discountForm.classList.remove('is-error');
        discountForm.classList.add('is-success');
        showAppliedCodes(updatedCart);
        setLoadingState(false);

        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      } else if (!isFoundCode && existingDiscountsRemoved) {
        // New code rejected and existing discounts removed - they're incompatible
        // Restore the previous discounts
        const restoreFormData = new FormData();
        restoreFormData.append('discount', [...existingTitles, ...existingDiscountCodes].join(','));
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: restoreFormData
        });
        showError(theme.settings.discount_form_error_cant_combine);
        setLoadingState(false);
      } else if (isFoundCode && !isApplicableCode) {
        showError(theme.settings.discount_form_error_not_applicable);
        setLoadingState(false);
      } else {
        showError(theme.settings.discount_form_error_invalid_code);
        setLoadingState(false);
      }

      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } catch (error) {
      console.error('Error:', error);
      showError(theme.settings.discount_form_error_message);
      setLoadingState(false);
    }
  });

  function showError(message) {
    const discountFormSuccess = discountForm.querySelector('.discount__form-success');
    discountFormError.innerText = message;
    discountFormError.style.display = 'block';
    discountFormSuccess.style.display = 'none';
    discountFormSuccess.innerHTML = '';
    discountForm.classList.add('is-error');
    discountForm.classList.remove('is-success');
  }

  function setLoadingState(isLoading) {
    if (isLoading) {
      discountFormButton.disabled = true;
      discountFormButton.classList.add('is-loading');
      const originalText = discountFormButton.textContent;
      discountFormButton.setAttribute('data-original-text', originalText);
      discountFormButton.innerHTML = '<svg class="loading-circle" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle></svg>';
    } else {
      discountFormButton.disabled = false;
      discountFormButton.classList.remove('is-loading');
      const originalText = discountFormButton.getAttribute('data-original-text');
      discountFormButton.textContent = originalText || '{{ settings.discount_form_cta_text }}';
      discountFormButton.removeAttribute('data-original-text');
    }
  }

  function showAppliedCode(codeName) {
    const discountFormSuccess = discountForm.querySelector('.discount__form-success');
    discountFormSuccess.innerHTML = `
      <div class="discount__applied-code">
        <svg class="discount__applied-code-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.7804 3.53606C11.4947 3.53606 12.0738 4.11514 12.0738 4.82946C12.0738 5.54378 11.4947 6.12285 10.7804 6.12285C10.0661 6.12285 9.48702 5.54378 9.48702 4.82946C9.48702 4.11514 10.0661 3.53606 10.7804 3.53606Z" fill="#746969"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.52882 0.00170248C7.93542 -0.0220337 7.3591 0.203298 6.93917 0.623231L0.62323 6.93917C-0.207743 7.77014 -0.207741 9.11741 0.623231 9.94838L6.05162 15.3768C6.88259 16.2077 8.22986 16.2077 9.06083 15.3768L15.3768 9.06083C15.7967 8.6409 16.022 8.06458 15.9983 7.47118L15.7526 1.32801C15.7291 0.741217 15.2588 0.270901 14.672 0.247429L8.52882 0.00170248ZM7.82423 1.50829C7.99714 1.33538 8.23445 1.2426 8.47879 1.25237L14.5065 1.49348L14.7476 7.52121C14.7574 7.76555 14.6646 8.00286 14.4917 8.17577L8.17577 14.4917C7.83361 14.8339 7.27885 14.8339 6.93668 14.4917L1.50829 9.06332C1.16613 8.72115 1.16613 8.1664 1.50829 7.82423L7.82423 1.50829Z" fill="#746969"/>
        </svg>
        <span class="discount__applied-code-text">${codeName}</span>
        <button type="button" class="discount__remove-code" aria-label="Remove discount code" title="Remove code">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `;
    discountFormSuccess.style.display = 'block';
    discountFormInput.value = '';

    const removeButton = discountFormSuccess.querySelector('.discount__remove-code');
    removeButton.addEventListener('click', removeAppliedCode);
  }

  function showAppliedCodes(cartData) {
    const discountFormSuccess = discountForm.querySelector('.discount__form-success');
    const appliedCodes = cartData.discount_codes
      .filter(item => item.applicable === true)
      .map(item => item.code)
      .filter(code => code && code.trim()); // Filter out undefined and empty values
    
    // Deduplicate codes
    const uniqueAppliedCodes = [...new Set(appliedCodes)];

    if (uniqueAppliedCodes.length === 0) {
      discountFormSuccess.style.display = 'none';
      discountFormSuccess.innerHTML = '';
      return;
    }

    const codesHTML = uniqueAppliedCodes.map(code => `
      <div class="discount__applied-code">
        <svg class="discount__applied-code-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.7804 3.53606C11.4947 3.53606 12.0738 4.11514 12.0738 4.82946C12.0738 5.54378 11.4947 6.12285 10.7804 6.12285C10.0661 6.12285 9.48702 5.54378 9.48702 4.82946C9.48702 4.11514 10.0661 3.53606 10.7804 3.53606Z" fill="#746969"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.52882 0.00170248C7.93542 -0.0220337 7.3591 0.203298 6.93917 0.623231L0.62323 6.93917C-0.207743 7.77014 -0.207741 9.11741 0.623231 9.94838L6.05162 15.3768C6.88259 16.2077 8.22986 16.2077 9.06083 15.3768L15.3768 9.06083C15.7967 8.6409 16.022 8.06458 15.9983 7.47118L15.7526 1.32801C15.7291 0.741217 15.2588 0.270901 14.672 0.247429L8.52882 0.00170248ZM7.82423 1.50829C7.99714 1.33538 8.23445 1.2426 8.47879 1.25237L14.5065 1.49348L14.7476 7.52121C14.7574 7.76555 14.6646 8.00286 14.4917 8.17577L8.17577 14.4917C7.83361 14.8339 7.27885 14.8339 6.93668 14.4917L1.50829 9.06332C1.16613 8.72115 1.16613 8.1664 1.50829 7.82423L7.82423 1.50829Z" fill="#746969"/>
        </svg>
        <span class="discount__applied-code-text">${code}</span>
        <button type="button" class="discount__remove-code" data-code="${code}" aria-label="Remove discount code" title="Remove code">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `).join('');

    discountFormSuccess.innerHTML = `
      <div class="discount__success-message">${theme.settings.discount_form_success_message}</div>
      <div class="discount__applied-codes-container">${codesHTML}</div>
    `;
    discountFormSuccess.style.display = 'block';
    discountFormError.style.display = 'none';
    discountFormError.innerText = '';
    discountForm.classList.remove('is-error');
    discountForm.classList.add('is-success');
    discountFormInput.value = '';

    const removeButtons = discountFormSuccess.querySelectorAll('.discount__remove-code');
    removeButtons.forEach(button => {
      button.addEventListener('click', removeAppliedCode);
    });
  }

  async function removeAppliedCode(e) {
    e.preventDefault();
    e.stopPropagation();

    try {
      const codeToRemove = e.currentTarget.getAttribute('data-code');
      
      // Get current cart state
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartResponse.json();

      const appliedTitles = cartData.cart_level_discount_applications.map(item => item.title);
      const appliedCodes = cartData.discount_codes
        .filter(item => item.applicable === true)
        .map(item => item.code);
      const remainingDiscounts = [...appliedTitles, ...appliedCodes].filter(code => code.toLowerCase() !== codeToRemove.toLowerCase());

      const formData = new FormData();
      formData.append('discount', remainingDiscounts.join(','));

      const updateResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      });
      const updatedCart = await updateResponse.json();

      // Reset form state
      const discountFormSuccess = discountForm.querySelector('.discount__form-success');
      
      if (remainingDiscounts.length === 0) {
        discountFormSuccess.style.display = 'none';
        discountFormSuccess.innerHTML = '';
        discountForm.classList.remove('is-success');
      } else {
        showAppliedCodes(updatedCart);
      }
      
      discountFormInput.value = '';
      discountFormInput.focus();
      discountFormError.style.display = 'none';

      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } catch (error) {
      console.error('Error removing discount:', error);
    }
  }

  // Initialize - Display applied codes on page load
  async function initializeAppliedCodes() {
    // Reset form state first on page load to clear any stale state
    resetFormState();
    
    // Then fetch and display applied codes
    await refreshAppliedCodes();
  }

  // Refresh applied codes display (fetches current cart and shows applied codes)
  async function refreshAppliedCodes() {
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartResponse.json();

      const appliedTitles = cartData.cart_level_discount_applications.map(item => item.title);
      const appliedCodes = cartData.discount_codes
        .filter(item => item.applicable === true)
        .map(item => item.code);
      const hasAppliedCodes = appliedTitles.length > 0 || appliedCodes.length > 0;

      if (hasAppliedCodes) {
        discountForm.classList.add('is-success');
        showAppliedCodes(cartData);
      } else {
        discountForm.classList.remove('is-success');
        const discountFormSuccess = discountForm.querySelector('.discount__form-success');
        discountFormSuccess.style.display = 'none';
        discountFormSuccess.innerHTML = '';
      }
    } catch (error) {
      console.error('Error refreshing applied codes:', error);
    }
  }

  // Reset form state function (clears input and error states)
  function resetFormState() {
    // Clear all error state
    discountFormError.innerText = '';
    discountFormError.style.display = 'none';
    discountForm.classList.remove('is-error');
    
    // Clear input value and remove inline styles
    discountFormInput.value = '';
    discountFormInput.style.background = '';
    
    // Reset button state
    discountFormButton.disabled = false;
    discountFormButton.classList.remove('is-loading');
    discountFormButton.removeAttribute('data-original-text');
  }

  // Listen for drawer open event to reset form state and refresh applied codes
  document.addEventListener('drawerOpen', function () {
    // Check if the discount form is now visible (cart drawer is open)
    if (discountForm && discountForm.offsetParent !== null) {
      resetFormState();
      refreshAppliedCodes();
    }
  });

  // Listen for cart updates to refresh applied codes display
  document.addEventListener('ajaxProduct:added', function () {
    refreshAppliedCodes();
  });

  // Run initialization on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAppliedCodes);
  } else {
    initializeAppliedCodes();
  }
}
